import { ProfileDetail } from "@garther/interfaces";
import { useCreateMyProfileMutation, useSetAvatarMutation } from "@garther/query-hooks";
import { getErrorMessage, toast, useI18n } from "@garther/ui/libs";

export { profileKeys, useProfileByUserId as useProfileByUserQuery } from "@garther/query-hooks";

export function useUploadAvatar(
  options: {
    onSuccess?: (result: ProfileDetail) => void;
  } = {}
) {
  const { t } = useI18n();
  return useSetAvatarMutation({
    onSuccess: options.onSuccess,
    onError: (error) => toast.error(getErrorMessage(error) || t("common.error.tryAgain"))
  });
}

export function useCreateMyProfile(options: { onSuccess?: () => void } = {}) {
  const { t } = useI18n();
  return useCreateMyProfileMutation({
    onSuccess: options.onSuccess ? () => options.onSuccess!() : undefined,
    onError: (error) => toast.error(getErrorMessage(error) || t("common.error.tryAgain"))
  });
}
